<template>
  <div>
    <h1>테스트</h1>
    <vue-editor v-model="content"></vue-editor>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor
  },
  data: () => ({
    message: "Company.vue",
    content: null
  }),
  methods: {},
  computed: {},
  mounted() {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/test1.vue